// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__22bYY","description":"PatientConsentPreview_description__2CCB-"};